var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIconGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 16.5,
    height: 16.488,
    fill: "#62ada1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31952",
    "data-name": "Group 31952",
    transform: "translate(126 136) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(108 118)",
    opacity: 0.003
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 18,
    height: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(125.25 135.244) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864-2",
    "data-name": "Group 864",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66149",
    "data-name": "Path 66149",
    d: "M14.384,7.385V12.7a1.7,1.7,0,0,1-1.7,1.7H3.067a1.7,1.7,0,0,1-1.7-1.7V3.075a1.7,1.7,0,0,1,1.7-1.705h5.35L9.786,0H3.067A3.075,3.075,0,0,0,0,3.075V12.7a3.071,3.071,0,0,0,3.067,3.067h9.619A3.071,3.071,0,0,0,15.753,12.7V6.016Z",
    transform: "translate(0 0.721)",
    fill: "#62ada1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66150",
    "data-name": "Path 66150",
    d: "M9.372,1.369a1.284,1.284,0,0,1,.908,2.193L4.225,9.618a3.393,3.393,0,0,1-2.381,1l-.454,0,.007-.448a3.393,3.393,0,0,1,1-2.359L8.464,1.746a1.275,1.275,0,0,1,.908-.377M9.372,0A2.645,2.645,0,0,0,7.5.777L1.427,6.846a4.78,4.78,0,0,0-1.4,3.306L0,12l1.856-.016a4.779,4.779,0,0,0,3.338-1.4L11.249,4.53A2.654,2.654,0,0,0,9.372,0",
    transform: "translate(4.473 0)",
    fill: "#62ada1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGreen);
export default __webpack_public_path__ + "static/media/edit-icon-green.1ee9f4f8f4ff6cb5fea432f85a81997b.svg";
export { ForwardRef as ReactComponent };